import {Platform} from 'react-native';
import FastImage from 'react-native-fast-image';
import {getBottomSpace} from 'react-native-iphone-screen-helper';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const Content = styled.ScrollView.attrs(() => ({
  contentContainerStyle: {
    paddingHorizontal: 24,
    paddingBottom: RFValue(24),
  },
}))`
  flex: 1;
`;

export const InputGroup = styled.View``;

export const Form = styled.View``;

export const ButtonWrapper = styled.View`
  margin-top: ${RFValue(12)}px;
`;

export const FinesCardWrapper = styled.View`
  margin-top: ${RFValue(20)}px;
`;

export const Footer = styled.View`
  padding-bottom: ${Platform.OS === 'ios'
    ? getBottomSpace()
    : RFValue(20)}px;
`;

export const CustomPanel = styled.TouchableOpacity`
  border-radius: ${RFValue(10)}px;
  overflow: hidden;
`;

export const PanelImage = styled(FastImage)`
  width: 100%;
  height: 100%;
`;
